export default function() {

  // Show more content (remove display none)
  $('.show-more-button').on('click', function() {
  	$(this).closest('.show-more-section').find('.show-more-container').removeClass('d-none');
    $(this).remove();
  })

}
